import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import Icon from "~/features/common/components/icons/Icon/index";
import { useAuth } from "~/features/common/context/AuthContext";
import { OpenJobsBadge } from "./OpenJobsBadge";
import type { SideBarNavigation } from "./SidebarNavigationLinks";

const SideBarItemButton = ({ collapsed, item }: { collapsed: boolean; item: SideBarNavigation }) => {
  const navigate = useNavigate();
  const { isProUser } = useAuth();

  return (
    <div className="relative flex w-full">
      <button
        type="button"
        data-testid={`${item.name.toLowerCase()}-sidebar-navigation`}
        className={clsx(
          !item.isactive && "cursor-default",
          collapsed && "justify-center",
          "flex w-full items-center  focus:outline-none",
        )}
        onClick={
          (item.isactive && item.availableInLightVersion) || isProUser
            ? () => {
                if (item.href) {
                  navigate(item.href);
                } else if (item.action) {
                  item.action();
                }
              }
            : undefined
        }>
        <div
          className={clsx(
            item.isactive && (item.availableInLightVersion || isProUser)
              ? "text-gray-400 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-gray-300"
              : "cursor-default text-gray-300  dark:text-gray-600",
            "h-6 w-6",
          )}>
          <Icon icon={item.icon} aria-hidden="true" size="sm" className="mt-1" />
        </div>
        {!collapsed && <span className="ml-3 text-left">{item.name}</span>}
        {item.name === "Jobs" && <OpenJobsBadge collapsed={collapsed} />}
      </button>
      {!collapsed &&
        item.isactive &&
        (item.availableInLightVersion || isProUser) &&
        item.children &&
        item.children?.length > 0 && (
          <div className="text-right">
            <Icon className="text-gray-400 dark:text-gray-100" icon={faChevronRight} />
          </div>
        )}
    </div>
  );
};

export default SideBarItemButton;
